export default {
  alert: false,
  alert2: true,
  login: {}
}
